import {Form, Modal,  App,   Row, Col, Space,} from 'antd'     
import { useCbpdjAddMutation } from '../../store/DianShangYeWuApi';
import React, { useState } from 'react'
import classes from './costInvoice.module.css'
import Icon from '../../cpn/Icon';
import OCRTextArea from '../../cpn/OCRTextArea';
import UploadPic from '../../cpn/UploadPic';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import dayjs from 'dayjs';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
import CostListWithId from '../../document/cost/CostListWithId';
function CostInvoiceAdd(props) {    
    const { message } = App.useApp();
    const [open,setOpen] = useState(false);
    const [info,setInfo] = useState({
        'cbpdj_qy_id': props.qy_id,
        'cbpdj_qy_name': props.qy_name,
        'cbpdj_uid': props.yh_id,
        'cbpdj_uname': props.yh_name,
        'cbpdj_kh_id': props.selectedddzc_kh_id,
        'cbpdj_kh_name': props.selectedddzc_kh_name,
        'cbpdj_state': '',
        'cbpdj_image_file': '',
        'cbpdj_image_name': '',
        'cbpdj_ddzc_id': props.selectedddzc_id,
        'cbpdj_amount': props.selectedddzc_amount,
        'cbpdj_content': '',
        'cbpdj_bm_id': '',
        'cbpdj_bm_name': ''
    })
    const [form] = Form.useForm();
    const [add] = useCbpdjAddMutation();
    
    // 当面板打开时重置表单到初始值
    React.useEffect(() => {
        if (open) {
            form.resetFields();
        }
    }, [open, form]);

    return (
        <>
            <Icon type='add' onClick={() => {
                if(props.selectedddzc_id.length === 0){
                    message.error('请勾选付款单，然后点击新增按钮！');
                    return;
                }
                setOpen(true)
            }} />
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 7}}
                    wrapperCol={{ span: 17 }}
                    initialValues={{
                        cbpdj_price: 0.01,
                        cbpdj_num: 1,
                        cbpdj_date: props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                        cbpdj_bm_name: props.dsbzd_bm_id ? String(props.dsbzd_bm_id) : undefined, // Select 需要的是 value（ID），统一转换为字符串
                    }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #339900',borderLeft:'3px solid #339900'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#339900',borderTop:'3px solid #339900'}}>成本票登记</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #339900',borderRight:'3px solid #339900'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #339900',color:'#339900'}}><Asterisk color='red'/> 付款单号</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <CostListWithId
                                id={props.selectedddzc_id}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                            />
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 成本票金额</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <span >￥</span>{Number(props.selectedddzc_amount).toLocaleString('zh-CN', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}                                                 
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #339900'}}>
                            <ReportDeptSelect
                                yh_id={props.yh_id}
                                wrapperCol={{span:24}}
                                placeholder='请选择部门'
                                qy_id={props.qy_id}
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, cbpdj_bm_id: e, cbpdj_bm_name: f }))
                                }}
                                name="cbpdj_bm_name"
                                defaultId={props.dsbzd_bm_id ? String(props.dsbzd_bm_id) : undefined}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #339900'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           {props.selectedddzc_kh_name}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 上传成本票</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #339900'}}>
                            <UploadPic
                                name='cbpdj_image'
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, cbpdj_image_file: e, cbpdj_image_name: f }))
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #339900',borderBottom:'3px solid #339900'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #339900'}}>
                            <Form.Item name='cbpdj_content' noStyle>
                                <OCRTextArea
                                    value={info.cbpdj_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, cbpdj_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom:'3px solid #339900'}}>提交记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #339900'}}>{props.yh_name}</Col> 
                        <Col span={2} className={classes.col_middle_label} style={{borderBottom:'3px solid #339900'}}>编号</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{display:'flex',alignItems:'center',justifyContent:'left',borderRight:'3px solid #339900',borderBottom:'3px solid #339900'}}></Col>    
                                                               
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    type='submit' 
                                    title='提交'
                                    onClick={() => {
                                        if(props.selectedddzc_amount === 0){
                                            message.error('请输入金额');
                                            return;
                                        }
                                        if(props.selectedddzc_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.cbpdj_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }        
                                        if(info.cbpdj_image_file === ''){
                                            message.error('请上传成本票');
                                            return;
                                        }
                                        add({
                                            'cbpdj_qy_id': props.qy_id,
                                            'cbpdj_qy_name': props.qy_name,
                                            'cbpdj_uid': props.yh_id,
                                            'cbpdj_uname': props.yh_name,
                                            'cbpdj_kh_id': props.selectedddzc_kh_id,
                                            'cbpdj_kh_name': props.selectedddzc_kh_name,
                                            'cbpdj_state': '1',
                                            'cbpdj_image_file': info.cbpdj_image_file,
                                            'cbpdj_image_name': info.cbpdj_image_name,
                                            'cbpdj_ddzc_id': props.selectedddzc_id,
                                            'cbpdj_amount': props.selectedddzc_amount,
                                            'cbpdj_content': info.cbpdj_content,
                                            'cbpdj_bm_id': info.cbpdj_bm_id,
                                            'cbpdj_bm_name': info.cbpdj_bm_name
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('提交成功');
                                                form.resetFields();  
                                            if (props.onReset) {
                                                props.onReset(); // 通用回调（若有传递）
                                            }
                                            if (typeof props.start === 'function') {
                                                props.start(); // 优先实现与ExpenseInvoiceExpenseList类似，通知父组件重置
                                            }
                                            }else{
                                                message.error('提交失败！' + res.data.Message);
                                            }
                                        })     
                                    }} 
                                />
                                <Icon 
                                    type='reset' 
                                    onClick={() => {
                                        form.resetFields();
                                        setInfo(prevState => ({ 
                                            ...prevState, 
                                            'cbpdj_qy_id': props.qy_id,
                                            'cbpdj_qy_name': props.qy_name,
                                            'cbpdj_uid': props.yh_id,
                                            'cbpdj_uname': props.yh_name,
                                            'cbpdj_kh_id': props.selectedddzc_kh_id,
                                            'cbpdj_kh_name': props.selectedddzc_kh_name,
                                            'cbpdj_state': '1',
                                            'cbpdj_image_file': '',
                                            'cbpdj_image_name': '',
                                            'cbpdj_ddzc_id': props.selectedddzc_id,
                                            'cbpdj_amount': props.selectedddzc_amount,
                                            'cbpdj_content': '',
                                            'cbpdj_bm_id': '',
                                            'cbpdj_bm_name': ''
                                        }))
                                    }} 
                                />
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default CostInvoiceAdd